import { render, staticRenderFns } from "./DeclarationsObligatoires.vue?vue&type=template&id=72e11eee&scoped=true"
import script from "./DeclarationsObligatoires.vue?vue&type=script&lang=js"
export * from "./DeclarationsObligatoires.vue?vue&type=script&lang=js"
import style0 from "./DeclarationsObligatoires.vue?vue&type=style&index=0&id=72e11eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e11eee",
  null
  
)

export default component.exports